module.exports = __webpack_public_path__ + "static/media/emissor-r-6.5a2a1705.png";